export default "__VITE_ASSET__f7fd5484__"